import React, { useState, useEffect } from 'react';
import styles from './BuyPackPage.module.css';
import packs from '../../constants/packs.json';
import { useStepContext } from '@mui/material';

const defaultImage =
  'https://sharetribe.imgix.net/6644cdce-c443-44fc-a95e-d3abbca7a3b9/667d7d2a-5050-4c12-87ae-ce8e30c0fec7?auto=format&fit=clip&h=2400&w=2400&s=d9834d8017f124e381cdd4e21a3e2b6f';

export default function BuyPackPage() {
  const handleImageError = e => {
    e.target.src = defaultImage;
  };
  const [pack, setPack] = useState('vlogger');

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const packParam = urlParams.get('pack');

    if (packParam) {
      setPack(packParam);
      // Set cookie for 7 days
    }
  }, []);

  return (
    <div className={styles.container}>
      {/* Hero Section (Banner only text) */}
      <section className={styles.hero}>
        <h1 className={styles.heroTitle}>Pack Vlogger</h1>
      </section>

      {/* Main Pack Card */}
      <div className={styles.card}>
        <div className={styles.cardTop}>
          <div className={styles.priceTag}>€49 / día</div>
          <h3 className={styles.cardTitle}>¿Qué incluye?</h3>

          <div className={styles.productList}>
            {packs
              .slice(pack === 'vlogger' ? 0 : 3, pack === 'vlogger' ? 3 : packs.length)
              .map(({ img, name, link }, i) => (
                <div className={styles.productItem} key={i}>
                  <img
                    src={img}
                    alt={img}
                    className={styles.productImage}
                    onError={handleImageError}
                  />
                  <span className={styles.productLabel}>{name}</span>
                  <a target="_blank" href={link}>
                    <button className={styles.button}>Alquilar ahora</button>
                  </a>
                </div>
              ))}
          </div>
        </div>

        <div className={styles.cardBottom}>
          <div className={styles.cardText}>
            <h3 className={styles.subtitle}>Detalles del Pack</h3>
            <ul className={styles.featuresList}>
              <li>Cámara Sony ZV-E10 (4K, pantalla abatible)</li>
              <li>Micrófono RODE Wireless GO II</li>
              <li>Estabilizador DJI RS3 Pro</li>
              <li>Maleta de transporte segura</li>
            </ul>
          </div>
          {/* <button className={styles.buyButton}>Alquilar ahora</button> */}
        </div>
      </div>
    </div>
  );
}
